import React, { useState } from "react";
import { Container, Overline } from "@/components/common";
import PageHero from "@/components/PageHero";
import EnquiryForm from "@/components/EnquiryForm";

function FormPicker({ options, defaultType }) {
  const [active, setActive] = useState(defaultType);
  const tab = options.find((t) => t.key === active);
  return (
    <div className="grid gap-12 md:grid-cols-12">
      <aside className="md:col-span-4">
        <Overline className="text-gold-dark">Choose an option</Overline>
        <div className="mt-4 flex flex-col gap-1">
          {options.map((t) => (
            <button key={t.key} data-testid={`option-${t.key}-${t.label.replace(/\s/g, "-")}`} onClick={() => setActive(t.key + t.label)}
              className={`rounded-md px-4 py-3 text-left text-sm font-medium transition-colors ${active === t.key + t.label ? "bg-navy text-white" : "text-navy/70 hover:bg-softgrey"}`}>
              {t.label}
            </button>
          ))}
        </div>
      </aside>
      <div className="md:col-span-8">
        <h2 className="mb-6 font-serif text-3xl text-navy">{tab.label}</h2>
        <EnquiryForm key={active} type={tab.key} fields={tab.fields} submitLabel="Submit" />
      </div>
    </div>
  );
}

const BASE = [
  { name: "name", label: "Name", required: true }, { name: "email", label: "Email", type: "email", required: true },
  { name: "organization", label: "Organization" }, { name: "message", label: "Message", area: true },
];

export function Collaborate() {
  const options = [
    "Research Collaboration", "Clinical Trial Collaboration", "Academic Collaboration", "NGO Collaboration",
    "CSR Partnership", "Cancer Camp Partnership", "Speaking Engagement", "Media Enquiry", "Community Programme Invitation",
  ].map((label) => ({ key: label.includes("Media") ? "media" : label.includes("Speaking") ? "speaking" : label.includes("Research") || label.includes("Trial") || label.includes("Academic") ? "research" : label.includes("NGO") || label.includes("CSR") || label.includes("Community") || label.includes("Camp") ? "collaborate" : "collaborate", label, fields: [...BASE, { name: "subject", label: "Subject / Focus" }] }));
  return (
    <div data-testid="collaborate-page">
      <PageHero label="Collaborate" title="Professional & Organizational Collaboration"
        intro="Partner with Dr. Sirohi on research, clinical trials, academic work, community programmes and more."
        image="https://images.unsplash.com/photo-1654609160632-7324716196fb?crop=entropy&cs=srgb&fm=jpg" />
      <section className="bg-white py-16"><Container><FormPicker options={options} defaultType={options[0].key + options[0].label} /></Container></section>
    </div>
  );
}

export function GetInvolved() {
  const options = [
    { key: "volunteer", label: "Volunteer With Us" },
    { key: "partnership", label: "Become a Partner" },
    { key: "partnership", label: "Sponsor a Camp" },
    { key: "ngo", label: "Invite to a Community Programme" },
    { key: "ngo", label: "Organize a Screening Camp" },
    { key: "ngo", label: "Support NICCI" },
    { key: "volunteer", label: "Join Awareness Campaigns" },
  ].map((o) => ({ ...o, fields: [...BASE, { name: "country", label: "Country / Region" }] }));
  return (
    <div data-testid="get-involved-page">
      <PageHero label="Get Involved" title="Join the Movement Against Cancer"
        intro="Volunteer, partner, sponsor a camp or support NICCI — there are many ways to make an impact."
        image="https://images.unsplash.com/photo-1654609160632-7324716196fb?crop=entropy&cs=srgb&fm=jpg" />
      <section className="bg-white py-16"><Container><FormPicker options={options} defaultType={options[0].key + options[0].label} /></Container></section>
    </div>
  );
}
